import { Card, Flex, Spin } from 'antd'

export const LoadingCard: React.FC = () => {
  return (
    <Card style={{ padding: 50 }}>
      <Flex justify="center" align="center">
        <Spin />
      </Flex>
    </Card>
  )
}
